import { toCents, correctPrice } from '@/utils/helpers';

export default class Contract {

  constructor(params) {
    const getters = [
      'lastTradePriceAsCents',
      'lastClosePriceAsCents',
      'changePriceAsCents',
      'userAveragePricePerShareAsCents',
      'userChangePriceAsCents',
      'buyYesCostAsCents',
      'buyNoCostAsCents',
      'sellYesCostAsCents',
      'sellNoCostAsCents',
      'userOpenOrders',
      'mode',
    ];
    Object.keys(params).forEach((key) => {
      if (getters.indexOf(key) < 0) { // to avoid setter exception
        this[key] = params[key];
      }
    });
  }

  get lastTradePriceAsCents() {
    return toCents(this.lastTradePrice);
  }

  get lastClosePriceAsCents() {
    return toCents(this.lastClosePrice);
  }

  get changePriceAsCents() {
    return this.lastTradePriceAsCents - this.lastClosePriceAsCents;
  }

  get userAveragePricePerShareAsCents() {
    return toCents(this.userAveragePricePerShare);
  }

  get userChangePriceAsCents() {
    const roundedAverage = Math.round(this.userAveragePricePerShare * 100) / 100;
    if (this.mode === 'no') {
      return toCents(1 - this.lastTradePrice - roundedAverage);
    }
    return toCents(this.lastTradePrice - roundedAverage);
  }

  get buyYesCostAsCents() {
    return correctPrice(toCents(this.bestYesPrice || this.bestYesCost));
  }

  get buyNoCostAsCents() {
    return correctPrice(toCents(this.bestNoPrice || this.bestNoCost));
  }

  get sellYesCostAsCents() {
    return correctPrice(100 - this.buyNoCostAsCents);
  }

  get sellNoCostAsCents() {
    return correctPrice(100 - this.buyYesCostAsCents);
  }

  get userOpenOrders() {
    return this.userOpenOrdersBuyQuantity + this.userOpenOrdersSellQuantity;
  }

  get mode() {
    if (this.userQuantity === 0 && this.userOpenOrders === 0) return '';
    if (this.userPrediction === 0) return 'no';
    if (this.userPrediction === 1) return 'yes';
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/models/contract.js